import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
  type: "button",
  disabled: ""
}
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = {
  key: 0,
  class: "d-sm-flex align-items-center"
}
const _hoisted_10 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-end pe-0 sm" }
const _hoisted_14 = { class: "dropdown" }
const _hoisted_15 = { class: "dropdown-menu" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "dropdown-item d-flex align-items-center" }
const _hoisted_18 = { class: "dropdown-item d-flex align-items-center" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_UpEmplacementModal = _resolveComponent("UpEmplacementModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.valideEtape3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.telecharger && _ctx.telecharger(...args))),
                disabled: _ctx.isLoading,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                type: "button"
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "flaticon-download position-relative ms-5 fs-12" }, null, -1)),
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Exporter"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("span", {
                        class: "spinner-grow spinner-grow-sm me-2",
                        role: "status",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode(" Export en cours... ", -1)
                    ]))]))
              ], 8, _hoisted_4))
            : _createCommentVNode("", true),
          (!_ctx.valideEtape3)
            ? (_openBlock(), _createElementBlock("button", _hoisted_7, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("span", {
                  class: "spinner-grow spinner-grow-sm",
                  role: "status",
                  "aria-hidden": "true"
                }, null, -1),
                _createElementVNode("span", { class: "visually-hidden" }, "Chargement...", -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot clé ", -1)),
            _createVNode(_component_Field, {
              modelValue: _ctx.motCle,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.motCle) = $event)),
              name: "mot",
              type: "text",
              "aria-disabled": "true",
              class: "form-control shadow-none fs-md-15 text-black",
              placeholder: "Recherche par mot clé"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "mot",
              class: "text-danger"
            })
          ])
        ]),
        (_ctx.checkParentPermission(['MettreAJourEmplacement','CreationEmplacement']))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_router_link, {
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                to: "/ajouter-emplacement"
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                  _createTextVNode(" Ajouter un emplacement ", -1)
                ]))]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-md-12" }, null, -1)),
        _cache[13] || (_cache[13] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("table", _hoisted_12, [
            _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " A code "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " N Code "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Locataire "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Exploitant "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Secteur "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Activité "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Parent Emplacement "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Détail "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Loyer "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                }, " Actions ")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usagers, (us, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", {
                    class: _normalizeClass(["shadow-none lh-1 fw-medium", us.estFils == true ? 'text-danger' : ''])
                  }, _toDisplayString(us.codeemp), 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(["shadow-none lh-1 fw-medium", us.estFils == true ? 'text-danger' : ''])
                  }, _toDisplayString(us.ncode_emp), 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(["shadow-none lh-1 fw-medium", us.estFils == true ? 'text-danger' : ''])
                  }, _toDisplayString(us.contrats.length > 0 ? us.contrats[0].locataire : us.nomLocataire), 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(["shadow-none lh-1 fw-medium", us.estFils == true ? 'text-danger' : 'text-black-emphasis'])
                  }, _toDisplayString(us.contrats.length > 0 ? us.contrats[0].usagers : us.nomExploitant), 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(["shadow-none lh-1 fw-medium", us.estFils == true ? 'text-danger' : 'text-black-emphasis'])
                  }, _toDisplayString(us?.secteur?.libelle_secteur), 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(["shadow-none lh-1 fw-medium", us.estFils == true ? 'text-danger' : 'text-black-emphasis'])
                  }, _toDisplayString(_ctx.afficher20Caracteres(us?.activite?.activite_nom)), 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(["shadow-none lh-1 fw-medium", us.estFils == true ? 'text-danger' : 'text-black-emphasis'])
                  }, _toDisplayString(_ctx.afficher20Caracteres(us?.emplacementParent?.ncode_emp)), 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(["shadow-none lh-1 fw-medium", us.estFils == true ? 'text-danger' : 'text-black-emphasis'])
                  }, _toDisplayString(_ctx.afficher20Caracteres(us?.nouveau_activite)), 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(["shadow-none lh-1 fw-medium", us.estFils == true ? 'text-danger' : 'text-black-emphasis'])
                  }, _toDisplayString(_ctx.separateur(us.montant_location)), 3),
                  _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[10] || (_cache[10] = _createElementVNode("span", {
                        class: "badge text-white bg-secondary fs-15 dropdown-toggle",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createTextVNode(" Actions "),
                        _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                      ], -1)),
                      _createElementVNode("ul", _hoisted_15, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: "#",
                            class: "dropdown-item d-flex align-items-center",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#UpEmplacementModal",
                            onClick: ($event: any) => (_ctx.modifUsager(us.codeemp)),
                            type: "button"
                          }, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Modifier ", -1)
                          ]))], 8, _hoisted_16)
                        ]),
                        _createElementVNode("li", _hoisted_17, [
                          _createVNode(_component_router_link, {
                            to: { name: 'ViewEmplacementPage', params: { id: us.codeemp } }
                          }, {
                            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                              _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Détails ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        _createElementVNode("li", _hoisted_18, [
                          _createElementVNode("a", {
                            onClick: ($event: any) => (_ctx.desactiverEmplacement(us.codeemp))
                          }, [...(_cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Supprimer place ", -1)
                          ]))], 8, _hoisted_19)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_UpEmplacementModal, {
      item: _ctx.selectedItem,
      onClose: _ctx.recharger,
      onOpen: _ctx.show_Modal
    }, null, 8, ["item", "onClose", "onOpen"])
  ], 64))
}